/**
 * Telegram error reporting — DISABLED 2026-04-29 per PM directive.
 *
 * All export functions are no-op stubs preserving previous signatures so
 * call-sites compile without changes. Network calls + bot tokens removed.
 *
 * To re-enable, restore from git history (commit before this disabling).
 */

export async function sendErrorToTelegram(
  _error: unknown,
  _additionalInfo?: {
    url?: string;
    userAgent?: string;
    environment?: string;
  },
): Promise<void> {
  // intentionally empty
}

interface ApiErrorReportLike {
  endpoint: string;
  method: string;
  statusCode: number;
  statusText: string;
  errorMessage: string;
  responseBody?: string;
  url?: string;
  userAgent?: string;
  environment?: string;
}

export async function sendApiErrorToTelegram(
  _error: ApiErrorReportLike,
): Promise<void> {
  // intentionally empty
}

export async function sendMessageToTelegram(_message: string): Promise<void> {
  // intentionally empty
}
